import { useEffect, useState } from 'react';
// utils
import { retryWeglotInitializing } from '../utils/weglotInitialize';

const useSettings = () => {
  const langFromStorage = window.localStorage?.getItem('wglang');
  const [language, setLanguage] = useState(langFromStorage ? langFromStorage : 'en');

  useEffect(() => {
    retryWeglotInitializing(50, (lang) => {
      setLanguage(lang);
    });
  }, []);

  return {
    language,
  };
};

export default useSettings;
